import { z } from 'zod';
import { handleSchema } from './primitives.js';
/**
 * Partner ecosystem contracts.
 *
 * These sit ABOVE the tenant boundary: a PartnerAccount and its Apps exist
 * across every store, and only an AppInstallation ties one to a specific
 * merchant. Nothing here is tenant-scoped, which is why the partner portal
 * never sends an X-Upweo-Shop header.
 */
export const PARTNER_ROLES = ['OWNER', 'DEVELOPER', 'MARKETER', 'VIEWER'];
export const APP_STATUSES = [
    'DRAFT',
    'PENDING_REVIEW',
    'APPROVED',
    'REJECTED',
    'SUSPENDED',
];
export const APP_DISTRIBUTIONS = ['PUBLIC', 'PRIVATE', 'CUSTOM'];
/** Scopes an app may request at install time. */
export const APP_SCOPES = [
    'read_products',
    'write_products',
    'read_orders',
    'write_orders',
    'read_customers',
    'write_customers',
    'read_inventory',
    'write_inventory',
];
export const createAppSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    handle: handleSchema.optional(),
    description: z.string().max(5000).optional(),
    appUrl: z.string().url().optional(),
    redirectUris: z.array(z.string().url()).max(10).default([]),
    scopes: z.array(z.enum(APP_SCOPES)).min(1, 'Request at least one scope'),
    distribution: z.enum(APP_DISTRIBUTIONS).default('PUBLIC'),
    isEmbedded: z.boolean().default(true),
});
export const updateAppSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    description: z.string().max(5000).nullable().optional(),
    appUrl: z.string().url().nullable().optional(),
    redirectUris: z.array(z.string().url()).max(10).optional(),
    scopes: z.array(z.enum(APP_SCOPES)).min(1).optional(),
    distribution: z.enum(APP_DISTRIBUTIONS).optional(),
    isEmbedded: z.boolean().optional(),
    /** DRAFT -> PENDING_REVIEW only; approval is a platform decision. */
    submitForReview: z.boolean().optional(),
});
//# sourceMappingURL=partner.js.map